import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { auth } from '../../services/auth';
import { ThemeToggle } from '../../components/ui/ThemeToggle';

function CreditsChip() {
  const { data: me } = useQuery({
    queryKey: ['me'],
    queryFn: auth.me,
    suspense: false,
    retry: false,
  });
  if (!me) return null;
  return (
    <Link
      to="/legal?plan=standard"
      title="Analysis credits remaining — click to buy more"
      className="rounded-full bg-emerald-600 px-3 py-1 text-sm font-semibold text-white dark:bg-emerald-500"
    >
      {me.credit_balance} credit{me.credit_balance === 1 ? '' : 's'}
    </Link>
  );
}

function NavLink({ to, children }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link
      to={to}
      className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
        isActive
          ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300'
          : 'text-slate-600 hover:bg-emerald-50 hover:text-emerald-700 dark:text-slate-300 dark:hover:bg-emerald-900/30'
      }`}
    >
      {children}
    </Link>
  );
}

export function DashboardLayout() {
  const navigate = useNavigate();
  const handleLogout = () => {
    auth.logout();
    navigate('/login');
  };
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <nav className="border-b border-emerald-100 bg-emerald-50/80 backdrop-blur dark:border-slate-700 dark:bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-xl font-bold tracking-tight text-transparent dark:from-emerald-400 dark:to-teal-400">
                  LeaseCheck
                </span>
              </div>
              <div className="hidden md:block">
                <div className="ml-10 flex items-baseline space-x-4">
                  <NavLink to="/dashboard">Dashboard</NavLink>
                  <NavLink to="/lease-analysis">Lease Analysis</NavLink>
                  <NavLink to="/toolkit">Get It In Writing</NavLink>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <CreditsChip />
              <ThemeToggle />
              <button
                onClick={handleLogout}
                className="rounded-md px-3 py-2 text-sm font-medium text-slate-500 transition-colors duration-200 hover:bg-emerald-100 hover:text-slate-700 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </main>
    </div>
  );
}
